import React from 'react';
import { useTranslation } from 'react-i18next';

import { LabeledSelect } from '../Input/LabeledSelect';

const MarketingStatus = ({ allowClear = true,
  disabled, ...props }) => {
  const [ t ] = useTranslation();

  return (
    <LabeledSelect
      placeholder={ t('fields.choose') }
      { ...props }
      disabled={ disabled }
      allowClear={ allowClear }
      options={ [
        { text: t('fields.currentMarketingStatus.marketed'), value: '1' },
        { text: t('fields.currentMarketingStatus.notMarketed'), value: '0' }
      ] }
    />
  );
};
export default MarketingStatus;
